import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useStore } from "../store/store-context";
import { useStateInRef } from 'seagull';
import { usePusher } from "./PusherProvider";
import { jsx as _jsx } from "react/jsx-runtime";
const PusherBusinessChannelContext = /*#__PURE__*/createContext({
  getChannel() {}
});
const scoutChannelName = businessId => "".concat(businessId, "-scout");
export const usePusherBusinessChannel = () => useContext(PusherBusinessChannelContext);

/** Responsible for subscribing/unsubscribing to the pusher business channel. */
export function PusherBusinessChannelProvider(props) {
  const pusher = usePusher();
  const userInfo = useStore(state => state.userInfo);
  const businessId = userInfo === null || userInfo === void 0 ? void 0 : userInfo.businessId();
  const [channelBusinessId, setChannelBusinessId] = useState();
  const getChannelBusinessId = useStateInRef(channelBusinessId);
  useEffect(() => {
    const shouldSubscribe = !!businessId;
    if (!shouldSubscribe) return;
    pusher.subscribe(businessId);
    pusher.subscribe(scoutChannelName(businessId));
    setChannelBusinessId(businessId);
    return () => {
      pusher.unsubscribe(businessId);
      pusher.unsubscribe(scoutChannelName(businessId));
      setChannelBusinessId(undefined);
    };
  }, [businessId]);
  const getChannel = useCallback(source => {
    const bid = getChannelBusinessId();
    return bid ? pusher.channel(source === 'scout' ? scoutChannelName(bid) : bid) : undefined;
  }, []);
  const value = useMemo(() => {
    return {
      getChannel,
      channelBusinessId
    };
  }, [getChannel, channelBusinessId]);
  return /*#__PURE__*/_jsx(PusherBusinessChannelContext.Provider, {
    value: value,
    children: props.children
  });
}